import { styled } from "@mui/material/styles";
import { DocEntry } from "../docsManifest";
import { DOCS_BORDER, DOCS_CONTENT_PX } from "../docsStyles";
import { PagerLink } from "./PagerLink";

// App.css sizes every <nav> for the top bar (height: 40px; padding: 10px).
const PagerNav = styled("nav")(({ theme }) => ({
  height: "auto",
  padding: theme.spacing(4),
  paddingLeft: theme.spacing(DOCS_CONTENT_PX.xs),
  paddingRight: theme.spacing(DOCS_CONTENT_PX.xs),
  borderTop: `1px solid ${DOCS_BORDER}`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: theme.spacing(4),
  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(DOCS_CONTENT_PX.sm),
    paddingRight: theme.spacing(DOCS_CONTENT_PX.sm),
    flexDirection: "row",
    gap: theme.spacing(8),
  },
  [theme.breakpoints.up("md")]: {
    paddingLeft: theme.spacing(DOCS_CONTENT_PX.md),
    paddingRight: theme.spacing(DOCS_CONTENT_PX.md),
  },
}));

const PagerCell = styled("div")({ flex: 1, minWidth: 0 });

interface DocsPagerProps {
  prev?: DocEntry;
  next?: DocEntry;
}

export const DocsPager = ({ prev, next }: DocsPagerProps) => {
  if (!prev && !next) {
    return null;
  }
  return (
    <PagerNav aria-label="Doc pages">
      <PagerCell>
        {prev && <PagerLink doc={prev} label="Previous" align="left" />}
      </PagerCell>
      <PagerCell>
        {next && <PagerLink doc={next} label="Next" align="right" />}
      </PagerCell>
    </PagerNav>
  );
};
